import { useEffect, useRef } from "react";

import { useAppSelector } from "store/index";
import { selectCurrentClassUser, selectCurrentSection } from "store/selectors";
import { AutoMuteService } from "utils/auto-mute-service";

/**
 * Unified hook that handles all auto-mute scenarios:
 * - Breakout room returns
 * - Any other future auto-mute triggers
 */
export const useUnifiedAutoMute = ({ isInVirtualClass }: { isInVirtualClass: boolean }) => {
  const currentClassUser = useAppSelector(selectCurrentClassUser);
  const currentSection = useAppSelector(selectCurrentSection);
  const previousBreakoutGroupId = useRef<string | null>(null);

  // Handle breakout return auto-mute
  useEffect(() => {
    if (!isInVirtualClass) {
      return;
    }

    const currentBreakoutGroupId = currentClassUser?.breakout_group_id || null;

    const scenario = AutoMuteService.detectScenario(
      currentClassUser || null,
      previousBreakoutGroupId.current,
    );

    if (scenario === "breakout_return" || scenario === "breakout_listening") {
      AutoMuteService.handleAutoMute(currentSection, scenario);
    }

    // Update the previous state for next comparison
    previousBreakoutGroupId.current = currentBreakoutGroupId;
  }, [currentClassUser?.breakout_group_id, currentClassUser, currentSection, isInVirtualClass]);
};
